import { 
  RETRY_DISPATCH_SERVICE_FAILED, 
  RETRY_DISPATCH_SERVICE_SUCCESS, 
  RETRY_DISPATCH_SERVICE_LOADING, 
  RESET_DISPATCH_SERVICE 
} from "../types"

const initialState = {
    loading: false,
    error: false,
    message: null,
    success: false,
    data: null
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case RETRY_DISPATCH_SERVICE_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          message: null,
          success: false,
          data: null
        }
      case RETRY_DISPATCH_SERVICE_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          message: action.payload,
          success: false,
          data: null
        }
      case RETRY_DISPATCH_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          message: null,
          success: true,
          data: action.payload
        }
      default:
        return state
    }
  }